enum PermissionGateName {
  ACCOUNTING
  ACRE_CASE_IMPORT
  ACRE_ORGANISATION_CREATE_REG_ORG
  APPLY_PAYMENT_LEDGER
  CASE_CHANGE_OWNER
  CLIENT_VIEW_PROTECTED
  CREATE_CASE_LEDGER
  DELETE_LEDGER
  EDIT_CASE
  EDIT_CASE_ADD_NEW
  EDIT_CASE_FLAGS
  EDIT_CASE_GENERATE_ILLUSTRATION
  EDIT_CASE_GENERATE_REASONS_WHY
  EDIT_CASE_LEDGER
  EDIT_CASE_REQUIREMENTS
  EDIT_CASE_SUITABILITY_DETAILS
  EDIT_CASE_UPLOAD_DOCUMENT
  EDIT_CASE_VERIFY_ACCEPTANCE
  EDIT_CLIENT
  EDIT_CLIENT_PROFILE_ALL
  EDIT_CLIENT_RESTRICTED
  EDIT_CLIENT_UPLOAD_DOCUMENT
  EDIT_CLIENT_VERIFY_IDD
  EDIT_GENERAL_INSURANCE
  EDIT_GENERAL_INSURANCE_PROVISIONAL
  EDIT_ORGANISATION_COMPANY_INFORMATION_COMPANY_SETTINGS
  EDIT_ORGANISATION_GENERAL_INSURANCE_COMPANY_SETTINGS
  EDIT_ORGANISATION_MORTGAGE_FEES_COMPANY_SETTINGS
  EDIT_PROVIDER_STATEMENT
  EDIT_USER_STATUS_COMPANY_SETTINGS
  EDIT_UNLINKED_PAYMENTS_LEDGER
  FIRM_MANAGETEMPLATES
  GROUP_EDIT_GROUP
  GROUP_VIEW_GROUP
  MANAGE_ORGANISATION
  ORGANISATION_CREATE_AR_ORG
  ORGANISATION_CREATE_INTRODUCER_ORG
  ORGANISATION_EDIT_METADATA
  ORGANISATION_EDIT_ORG
  ORGANISATION_EDIT_ORG_FINANCIAL_CONFIGURATION
  ORGANISATION_EDIT_PROTECTED
  ORGANISATION_EDIT_SYSTEM_METADATA
  ORGANISATION_REPORTING
  ORGANISATION_VIEW
  ORGANISATION_VIEW_ORG_FINANCIAL_CONFIGURATION
  PERMISSIONS_EDIT_PERMISSION
  PERMISSIONS_EDIT_REGULATED_PERMISSION
  PERMISSIONS_VIEW_PERMISSIONS
  REFERRAL_PARTNERS
  REGULATED_COMPLIANCE_ADDCASENOTES
  REGULATED_COMPLIANCE_APPROVEADVICE
  REGULATED_COMPLIANCE_APPROVEAML
  REGULATED_COMPLIANCE_APPROVECASES
  REGULATED_COMPLIANCE_APPROVEEIDVOVERRIDE
  REGULATED_COMPLIANCE_VIEWCASEDETAIL
  REGULATED_COMPLIANCE_VIEWCASENOTES
  REGULATED_COMPLIANCE_USERMANAGEMENT
  REGULATED_COMPLIANCE_UPLOADDOCUMENT
  REGULATED_DEBTCONSOLIDATION
  REGULATED_EQUITYRELEASE
  REGULATED_EQUITYRELEASE_PROVISIONAL
  REGULATED_GENERALINSURANCE
  REGULATED_GENERALINSURANCE_PROVISIONAL
  REGULATED_MORTGAGE
  REGULATED_MORTGAGE_PROVISIONAL
  REGULATED_PROTECTIONINSURANCE
  REGULATED_PROTECTIONINSURANCE_PROVISIONAL
  USER_CREATE_USER
  USER_EDIT_AUTHENTICATION
  USER_EDIT_USER
  USER_EDIT_USER_METADATA
  VIEW_BROKER_DASHBOARD
  VIEW_CASE_COMPLIANCE
  VIEW_CASE_EIDV
  VIEW_CASE_FLAGS
  VIEW_CASE_SECTION
  VIEW_CLIENT_SECTION
  VIEW_MI_DASHBOARD
  VIEW_OVERRIDE_CLIENT_EIDV
  VIEW_PROVIDER_STATEMENT
  VIEW_UNLINKED_PAYMENTS_LEDGER
  WRITE_OFF_LEDGER
}

enum PermissionType {
  INVALID_PERMISSION_TYPE
  REGULATED
  STANDARD
  ACRE
}

type PermissionScope {
  id: String
  type: String
}

input PermissionScopeInput {
  id: String
  type: String
}

input PermissionResolutionInput {
  permission_name: String
  scope: PermissionScopeInput
  assignee: PermissionResolutionAssigneeInput
}

enum PermissionResolutionAssigneeType {
  INVALID
  USER
}

input PermissionResolutionAssigneeInput {
  id: ID!
  type: PermissionResolutionAssigneeType!
}

type PermissionResolutionAssignee {
  id: ID
}

type PermissionResolution {
  permission_name: String
  scope: PermissionScope
  assignee: PermissionResolutionAssignee
  has_permission: Boolean
}

type PermissionResponse {
  permissions: [Permission!]!
}

type Permission {
  permission_id: ID!
  permission_name: String!
  permission_type: PermissionType
  description: String
  scopes: [String]
}

type PermissionAssignmentPagination {
  bookmark: String
  filter_group_id: String
  page_size: Int
  permission_assignment_details: Boolean
  show_disabled: Boolean
}

type PermissionAssignmentResponse {
  permission_assignments: [PermissionAssignment!]!
  next_page: PermissionAssignmentPagination
}

type PermissionAllowList {
  disabled: Boolean
  permission_id: ID!
  permission_assignment_id: ID
  permission_name: String!
  permission_type: PermissionType
  description: String
  scopes: [String]
}

type PermissionAssignment {
  permission_assignment_id: ID!
  permission_id: String!
  disabled: Boolean
  user_id: String
  user_scope_id: String
  group_id: String
  case_id: String
  organisation_id: String
  role_id: String
  client_id: String
}

type ResolvedPermissionResolution {
  gate: PermissionGateName!
  permission_name: String!
  has_permission: Boolean
  scope: PermissionScope
  assignee: PermissionResolutionAssignee
}

input PermissionAssignmentInput {
  permission_id: String!
  permission_assignment_id: String
  role_id: String
  client_id: String
  user_id: String
  user_scope_id: String
  group_id: String
  case_id: String
  organisation_id: String
  disabled: Boolean
}

input PermissionAssignmentBulkInput {
  permission_assignments: [PermissionAssignmentInput!]
}
